import { TextField } from '@sunwebgroup/uds-ui/fields/text-field'
import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from '@/intl'
import { isAnyNamedRoomWithSameName } from '@/scopes/checkout/groups/components/services/RoomSelection/selectors'
import {
  getErrorMessage,
} from '@/scopes/checkout/groups/components/services/RoomSelection/Sheet/FormFields/getErrorMessages'
import { useAvailableRoomsQuery } from '@/scopes/checkout/groups/domain/hooks'

export function RoomNameFormField() {
  const { formState, register, watch } = useFormContext()
  const { errors } = formState
  const { data } = useAvailableRoomsQuery()
  const { rooms } = data || {}
  const intl = useIntl()

  const watchedAssignationMethod = watch('assignationMethod')

  const validations = React.useMemo(
    () => ({
      ...({ roomWithSameNameAlreadyExists: (value: string) => {
        return !isAnyNamedRoomWithSameName(rooms, value)
      } }),
    }),
    [rooms],
  )

  const errorMessage = getErrorMessage(
    'newRoomName',
    errors,
    { requiredErrorMessage: intl.formatMessage({ id: 'groups_checkout_steps_room_selection_room_name_required_error_message' }), sameRoomErrorMessage: intl.formatMessage({ id: 'groups_checkout_steps_room_selection_room_name_same_room_error_message' }) },
  )
  return (
    <TextField
      label={intl.formatMessage({ id: 'groups_checkout_steps_room_selection_room_name_field_label' })}
      feedbackText={errorMessage}
      status={errors.newRoomName ? 'error' : 'default'}
      inputProps={register('newRoomName', {
        required: watchedAssignationMethod === 'specific',
        validate: validations,
      })}
      helpText={intl.formatMessage({ id: 'groups_checkout_steps_room_selection_room_name_field_help_text' })}
      name="newRoomName"
    />
  )
}
